import { Aspect } from '@teambit/harmony';

export const CompositionsAspect = Aspect.create({
  id: 'teambit.compositions/compositions',
  dependencies: [],
  defaultConfig: {},
});

export default CompositionsAspect;
